<!-- Filtro avanzado flotante superior -->
<app-advanced-filter #advFilter [fields]="advancedFilterFields" [showTrigger]="false"
    (filtersChange)="activeAdvancedFilters.set($event)">
</app-advanced-filter>

<!-- Cabecera estandarizada responsive -->
<app-page-header
    title="Historial de Solicitudes"
    mobileTitle="Historial"
    icon="fa-solid fa-clock-rotate-left"
    [hasOptions]="false">
</app-page-header>

<app-mobile-footer [visible]="appSettings.isMobile()">
    <input type="search"
        class="form-control mobile-footer-search"
        placeholder="Buscar socio, RUT, patente..."
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)">
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
        [class.btn-outline-primary]="advFilter.activeFiltersCount() > 0"
        (click)="advFilter.toggleOpen()">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (advFilter.activeFiltersCount() > 0) {
            <span class="badge bg-primary ms-1">{{ advFilter.activeFiltersCount() }}</span>
        }
    </button>
</app-mobile-footer>

@if (!appSettings.isMobile()) {
    <!-- Mini Dashboard de KPIs (Desktop) -->
    <div class="row mb-3">
        <div class="col-md-3 mb-2">
            <div class="panel h-100 border-0">
                <div class="panel-body p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="text-muted small text-uppercase fw-bold mb-1">Total finalizadas</h5>
                            <h3 class="mb-0 fw-bold">{{ totalRequestsCount() }}</h3>
                        </div>
                        <div class="text-secondary opacity-25">
                            <i class="fas fa-clipboard-list fa-3x"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="panel h-100 border-0 shadow-sm card-metric">
                <div class="panel-body p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="text-muted small text-uppercase fw-bold mb-1">Aprobadas</h5>
                            <h3 class="mb-0 fw-bold text-success">{{ approvedRequestsCount() }}</h3>
                        </div>
                        <div class="text-success opacity-25">
                            <i class="fas fa-check-double fa-3x"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="panel h-100 border-0 shadow-sm card-metric">
                <div class="panel-body p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="text-muted small text-uppercase fw-bold mb-1">Rechazadas</h5>
                            <h3 class="mb-0 fw-bold text-danger">{{ rejectedRequestsCount() }}</h3>
                        </div>
                        <div class="text-danger opacity-25">
                            <i class="fas fa-times-circle fa-3x"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 mb-2">
            <div class="panel h-100 border-0 shadow-sm card-metric">
                <div class="panel-body p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 class="text-muted small text-uppercase fw-bold mb-1">Desechadas</h5>
                            <h3 class="mb-0 fw-bold text-secondary">{{ discardedRequestsCount() }}</h3>
                        </div>
                        <div class="text-secondary opacity-25">
                            <i class="fas fa-trash-alt fa-3x"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @else {
    <!-- Mini Dashboard de KPIs (Movil) -->
    <div class="row g-2 mb-2">
        <div class="col-3">
            <div class="card border-0 shadow-sm p-2 text-center">
                <span class="text-muted small text-uppercase" style="font-size: 0.65rem;">Total</span>
                <span class="fw-bold fs-6">{{ totalRequestsCount() }}</span>
            </div>
        </div>
        <div class="col-3">
            <div class="card border-0 shadow-sm p-2 text-center">
                <span class="text-muted small text-uppercase" style="font-size: 0.65rem;">Aprob.</span>
                <span class="fw-bold fs-6 text-success">{{ approvedRequestsCount() }}</span>
            </div>
        </div>
        <div class="col-3">
            <div class="card border-0 shadow-sm p-2 text-center">
                <span class="text-muted small text-uppercase" style="font-size: 0.65rem;">Rech.</span>
                <span class="fw-bold fs-6 text-danger">{{ rejectedRequestsCount() }}</span>
            </div>
        </div>
        <div class="col-3">
            <div class="card border-0 shadow-sm p-2 text-center">
                <span class="text-muted small text-uppercase" style="font-size: 0.65rem;">Desech.</span>
                <span class="fw-bold fs-6 text-secondary">{{ discardedRequestsCount() }}</span>
            </div>
        </div>
    </div>
}

@if (!appSettings.isMobile()) {
    <!-- Panel de Filtros (Desktop) -->
    <div class="panel p-3 mb-3 border-0 shadow-sm">
        <div class="row align-items-end g-3">
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Desde</label>
                <ng-select [items]="periods()"
                           bindLabel="displayName"
                           bindValue="id"
                           [ngModel]="selectedPeriodStartId()"
                           (ngModelChange)="onPeriodStartChange($event)"
                           [clearable]="false"
                           placeholder="Desde">
                </ng-select>
            </div>
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Hasta</label>
                <ng-select [items]="filteredEndPeriods"
                           bindLabel="displayName"
                           bindValue="id"
                           [ngModel]="selectedPeriodEndId()"
                           (ngModelChange)="onPeriodEndChange($event)"
                           [clearable]="false"
                           placeholder="Hasta">
                </ng-select>
            </div>

            @if (!authService.isUserRole()) {
            <div class="col-md-3">
                <label class="form-label fw-bold small text-uppercase text-muted">Entidades</label>
                <ng-select [items]="roleEntities()"
                           bindLabel="name"
                           bindValue="code"
                           [multiple]="true"
                           [searchable]="true"
                           [clearable]="true"
                           placeholder="Todas las Entidades"
                           [ngModel]="selectedEntities()"
                           (ngModelChange)="selectedEntities.set($event)">
                </ng-select>
            </div>
            }

            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Proceso</label>
                <ng-select [items]="processes()"
                           bindLabel="name"
                           bindValue="slug"
                           [clearable]="true"
                           placeholder="Todos"
                           [ngModel]="selectedProcess()"
                           (ngModelChange)="selectedProcess.set($event)">
                </ng-select>
            </div>

            <div class="col-md-3">
                <label class="form-label fw-bold small text-uppercase text-muted">Estado</label>
                <ng-select [items]="statusOptions"
                           bindLabel="name"
                           bindValue="slug"
                           [clearable]="false"
                           placeholder="Estado"
                           [ngModel]="selectedStatus()"
                           (ngModelChange)="selectedStatus.set($event)">
                </ng-select>
            </div>

            <div class="col-md-12">
                <label class="form-label fw-bold small text-uppercase text-muted">Buscador</label>
                <div class="input-group">
                    <span class="input-group-text bg-white border-end-0"><i class="fas fa-search text-muted"></i></span>
                    <input type="text"
                           class="form-control border-start-0 ps-0"
                           placeholder="Buscar por socio, RUT, patente..."
                           [ngModel]="searchQuery()"
                           (ngModelChange)="searchQuery.set($event)">
                </div>
            </div>
        </div>
    </div>
}

@if (!appSettings.isMobile()) {
    <!-- Tabla del Historial (Desktop) -->
    <div class="panel p-3 mb-3 border-0 shadow-sm">
        <div class="table-responsive table-data">
            <table class="table table-hover table-sm align-middle">
                <thead>
                    <tr>
                        <th class="text-uppercase text-muted align-middle" style="width: 250px;">
                            <div class="d-inline-flex align-items-center gap-1">
                                <button type="button" class="filter-table-btn" (click)="advFilter.toggleOpen()" title="Filtros avanzados">
                                    <i class="fas fa-filter" [class.text-primary]="advFilter.activeFiltersCount() > 0"></i>
                                    @if(advFilter.activeFiltersCount() > 0) {
                                        <span class="filter-count-badge">{{ advFilter.activeFiltersCount() }}</span>
                                    }
                                </button>
                                <span>Entidad</span>
                            </div>
                        </th>
                        <th class="text-uppercase text-muted">Socio / Detalle</th>
                        <th class="text-uppercase text-muted" style="width: 200px;">Proceso</th>
                        <th class="text-uppercase text-muted" style="width: 170px;">Fecha / Periodo</th>
                        <th class="text-uppercase text-muted text-center" style="width: 150px;">Estado</th>
                        <th class="text-uppercase text-muted text-center" style="width: 100px;"><i class="fas fa-cogs"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @if(isLoading()) {
                        @for(i of [1, 2, 3, 4, 5]; track $index) {
                            <tr class="placeholder-glow">
                                <td class="align-middle"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                                <td class="align-middle"><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                                <td class="align-middle"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                                <td class="align-middle"><span class="placeholder placeholder-sm col-9 bg-gray-500"></span></td>
                                <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                                <td class="align-middle text-center"><span class="placeholder placeholder-sm col-4 bg-gray-500"></span></td>
                            </tr>
                        }
                    } @else {
                        @for(req of filteredRequests(); track req.uuid) {
                            <tr>
                                <td>
                                    {{ getEntityName(req.entityCode) }}
                                    @if (req.processSlug === 'TRANSFER' && req.targetEntityCode) {
                                        <span class="d-block small text-muted mt-1">
                                            → {{ getEntityName(req.targetEntityCode) }}
                                        </span>
                                        @if (isIncomingTransfer(req)) {
                                            <span class="badge border border-info text-info mt-1">Recepción</span>
                                        } @else if (isOutgoingTransfer(req)) {
                                            <span class="badge border border-secondary text-secondary mt-1">Salida</span>
                                        }
                                    }
                                </td>
                                <td>
                                    @if (req.processSlug === 'PAYMENT') {
                                        <span class="fw-bold">{{ getEntityName(req.entityCode) }}</span>
                                        <span class="text-muted block d-block small">Monto: ${{ (req.payment?.amount ?? req.amount ?? 0) | number:'1.0-0':'es-CL' }}</span>
                                    } @else {
                                        <span class="fw-bold">{{ req.party?.names }} {{ req.party?.lastNames }}</span>
                                        @if (req.processSlug === 'TRANSFER') {
                                            @if (transferReception(req); as rec) {
                                                <span class="text-muted d-block small">Recibida por {{ rec.actor }}{{ rec.at ? ' · ' + rec.at : '' }}</span>
                                            } @else {
                                                <span class="text-muted d-block small">Destino: {{ getEntityName(req.targetEntityCode) }}</span>
                                            }
                                        } @else {
                                            <span class="text-muted block d-block small">Patente: {{ req.vehicle?.plate ?? req.claim?.vehicle?.plate ?? 'S/P' }}</span>
                                        }
                                    }
                                </td>
                                <td>
                                    <span>
                                        {{ getProcessName(req.processSlug) }}
                                    </span>
                                </td>
                                <td>
                                    {{ req.createdAt | date:'dd/MM/yyyy HH:mm' }}
                                    @if (billingPeriodLabel(req); as per) {
                                        <span class="text-muted d-block small">Periodo {{ per }}</span>
                                    }
                                </td>
                                <td class="text-center">
                                    <span class="badge border" [ngClass]="req?.statusObj?.style">
                                        {{ req.statusObj?.name || req.statusSlug }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <div class="d-inline-flex gap-1">
                                        @if (canReactivate(req)) {
                                            <button type="button"
                                                    class="btn btn-outline-primary btn-xs"
                                                    (click)="reactivate(req)"
                                                    title="Reactivar borrador">
                                                <i class="fas fa-undo"></i>
                                            </button>
                                        }
                                        @if (canHardDelete(req)) {
                                            <button type="button"
                                                    class="btn btn-outline-danger btn-xs"
                                                    (click)="hardDelete(req)"
                                                    title="Eliminar definitivamente (soporte)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        }
                                        <button class="btn btn-outline-secondary btn-xs"
                                                (click)="openInforme(req, preview)"
                                                [disabled]="isGeneratingPdf() || !canViewInforme(req)"
                                                title="Ver informe">
                                            @if (isGeneratingPdf()) {
                                                <span class="spinner-border spinner-border-sm"></span>
                                            } @else {
                                                <i class="fas fa-file-pdf"></i>
                                            }
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        }
                    }

                    @if(!isLoading() && filteredRequests().length === 0) {
                        <tr>
                            <td colspan="6" class="text-center p-5">
                                <div class="py-4">
                                    <i class="fas fa-history fa-4x text-light mb-3"></i>
                                    <h4 class="text-muted fw-normal">No se encontraron registros</h4>
                                    <p class="text-muted small mb-0">Amplía el rango de periodos o cambia el estado para ver más solicitudes.</p>
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
} @else {
    <!-- Vista Movil: Tarjetas ListCard -->
    <div class="col-12 mobile-history-container">
        <!-- Barra de cabecera movil -->
        <div class="d-flex justify-content-between align-items-center mb-2 px-1">
            <span class="small text-muted fw-bold text-uppercase">
                Registros @if(!isLoading()) { ({{ filteredRequests().length }}) }
            </span>
        </div>

        <!-- Selector rapido de estado en movil -->
        <div class="mb-2">
            <ng-select [items]="statusOptions"
                       bindLabel="name"
                       bindValue="slug"
                       [clearable]="false"
                       placeholder="Estado"
                       class="border-0 shadow-sm bg-white rounded"
                       [ngModel]="selectedStatus()"
                       (ngModelChange)="selectedStatus.set($event)">
            </ng-select>
        </div>

        <!-- Contenedor con scroll para tarjetas -->
        <div class="mobile-cards-scroll">
            @if(isLoading()) {
                @for(i of [1, 2, 3, 4]; track $index) {
                    <app-list-card [isLoading]="true"></app-list-card>
                }
            } @else {
                @for(req of filteredRequests(); track req.uuid) {
                    <app-list-card>
                        <div cardTitle class="fw-bold text-dark text-truncate">
                            @if (req.processSlug === 'PAYMENT') {
                                {{ getEntityName(req.entityCode) }}
                            } @else {
                                {{ req.party?.names }} {{ req.party?.lastNames }}
                            }
                        </div>

                        <div cardBadge class="d-flex gap-1">
                            <span class="badge bg-light text-dark border">{{ getProcessName(req.processSlug) }}</span>
                            <span class="badge bg-secondary">{{ req.entityCode }}</span>
                        </div>

                        <div class="row g-1 text-muted small">
                            @if (req.processSlug === 'PAYMENT') {
                                <div class="col-12">
                                    <span class="text-muted">Entidad:</span> <span class="fw-semibold text-dark">{{ getEntityName(req.entityCode) }}</span>
                                </div>
                            } @else if (req.processSlug === 'TRANSFER') {
                                <div class="col-12">
                                    @if (transferReception(req); as rec) {
                                        <span class="text-muted">Recibida:</span> {{ rec.actor }}{{ rec.at ? ' · ' + rec.at : '' }}
                                    } @else {
                                        <span class="text-muted">Destino:</span> {{ getEntityName(req.targetEntityCode) }}
                                    }
                                </div>
                            } @else {
                                <div class="col-6">
                                    <i class="fa fa-car me-1 text-muted"></i>
                                    <span class="fw-semibold text-dark">{{ req.vehicle?.plate ?? req.claim?.vehicle?.plate ?? 'S/P' }}</span>
                                </div>
                            }
                            <div class="col-6" [class.text-end]="req.processSlug !== 'PAYMENT' && req.processSlug !== 'TRANSFER'">
                                <i class="fa fa-calendar me-1 text-muted"></i>
                                <span>{{ req.createdAt | date:'dd/MM/yyyy' }}</span>
                            </div>
                            @if (billingPeriodLabel(req); as per) {
                                <div class="col-12 text-muted">
                                    Periodo: {{ per }}
                                </div>
                            }
                        </div>

                        <div cardExtra>
                            <span class="text-muted text-uppercase fw-bold" style="font-size: 11px;">
                                @if (req.payment?.amount ?? req.amount) { Monto } @else { Estado }
                            </span>
                        </div>

                        <div cardAmount>
                            @if (req.payment?.amount ?? req.amount) {
                                <span class="fw-bold font-monospace fs-14 text-dark">${{ (req.payment?.amount ?? req.amount) | number:'1.0-0':'es-CL' }}</span>
                            } @else {
                                <span class="badge border" [ngClass]="req?.statusObj?.style">
                                    {{ req.statusObj?.name || req.statusSlug }}
                                </span>
                            }
                        </div>

                        <div cardActionsRow class="d-flex gap-2">
                            @if (canReactivate(req)) {
                                <button type="button"
                                        class="btn btn-outline-primary btn-sm flex-fill"
                                        (click)="$event.stopPropagation(); reactivate(req)">
                                    <i class="fas fa-undo me-1"></i>Reactivar
                                </button>
                            }
                            <button type="button"
                                    class="btn btn-outline-secondary btn-sm"
                                    [class.w-100]="!canReactivate(req)"
                                    [class.flex-fill]="canReactivate(req)"
                                    (click)="$event.stopPropagation(); openInforme(req, preview)"
                                    [disabled]="isGeneratingPdf() || !canViewInforme(req)">
                                <i class="fas fa-file-pdf me-1"></i>Informe
                            </button>
                        </div>
                    </app-list-card>
                }
            }

            @if(!isLoading() && filteredRequests().length === 0) {
                <div class="card border-0 shadow-sm p-4 text-center">
                    <i class="fas fa-history fa-3x text-muted opacity-50 mb-2"></i>
                    <h6 class="text-muted mb-1">No se encontraron registros</h6>
                    <small class="text-muted">Amplía el rango de periodos o cambia los filtros.</small>
                </div>
            }
        </div>

    </div>
}

<ng-template #preview let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Informe de solicitud</h4>
        <div class="ms-auto d-flex align-items-center">
            @if (pdfSrc) {
                <a [href]="pdfSrc" class="btn btn-outline-success btn-sm me-2" target="_blank">
                    <i class="fas fa-external-link-alt me-1"></i> Abrir en nueva pestaña
                </a>
            }
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
    </div>
    <div class="modal-body p-0 text-center bg-light">
        @if (pdfSrc) {
            <iframe [src]="pdfSrc" width="100%" height="750px" style="border: none;"></iframe>
        }
    </div>
</ng-template>

<app-claim-informe-pdf />
<app-membership-informe-pdf
    #membershipPdf
    [request]="selectedMembershipRequest()"
    [party]="selectedMembershipRequest()?.party"
    [vehicle]="selectedMembershipRequest()?.vehicle" />
